import 'jquery-validation'
import "jquery-validation/dist/additional-methods.js"
import Cookies from 'js-cookie';
import {recordEvent} from 'js/ts/tracking'

interface SupplierEmailResponse {
  message: string
  success: boolean
  supplierIdsAlreadyRecorded: number[]
  supplierIds: number[]
  error: boolean
  errorMessage: string
}

export default class ProductEmailSupplierForm {

  constructor() {
    $("#sitewide-overlay, #email-supplier-dialog .close, #email-supplier-dialog .cancel, #email-supplier-dialog .done")
      .on("click", () => $("#email-supplier-dialog, #sitewide-overlay").fadeOut())

    this.attachFormValidation()
    this.attachEventTracking()
    this.autoAdjustMessageBoxHeight()
  }

  private autoAdjustMessageBoxHeight() {
    const emailMessage = document.getElementById("email-supplier-message");
    if (emailMessage) {
      emailMessage.setAttribute("style", `height:${emailMessage.scrollHeight}px;`);
      emailMessage.addEventListener("input", () => {
        emailMessage.style.height = "auto";
        emailMessage.style.height = `${emailMessage.scrollHeight}px`;
      }, false);
    }
  }

  private attachFormValidation() {
    $("#email-supplier-form").validate({
      ignore: ':hidden:not(.do-not-ignore)',
      rules: {
        products: {
          required: true,
        },
        email: {
          required: true,
        },
        message: {
          required: true,
        },
        hiddenRecaptcha: {
          required: true,
          pattern: /^true$/,
        },
      },
      errorClass: "validation-error",
      errorElement: "span",
      messages: {
        products: {
          required: "Select one or more suppliers",
        },
        email: {
          required: "Enter your email address",
        },
        message: {
          required: "Enter a brief message",
        },
        hiddenRecaptcha: ''
      },
      errorPlacement: (error, element) => {
        if (element.attr("name") == "suppliers") {
          error.appendTo($('#email-supplier-dialog .multi-select'));
        } else {
          error.insertAfter(element);
        }
      },
      invalidHandler: (form, validator) => {
        if (!validator.numberOfInvalids())
          return;

        $('html, body').animate({
          scrollTop: ($(validator.errorList[0].element).offset().top - 50)
        }, 500);
      },
      submitHandler: () => {
        ProductEmailSupplierForm.showLoading()
        this.submitEmailSupplierForm()
      }
    });
  }

  private submitEmailSupplierForm() {
    $.ajax({
      url: "/ajax/product/email-supplier",
      type: "POST",
      data: $("#email-supplier-form").serialize(),
      timeout: 20000,
      dataType: "json",
    }).then((result: SupplierEmailResponse) => {
      if (result.error === true) {
        ProductEmailSupplierForm.showError(result.message)
      } else {
        this.showSuccess(result.message)
      }
      $("#email-supplier-dialog").removeClass("submitting")

      // We want to filter out any supplierIds that have already had a web lead recorded
      const filteredSupplierIds = result.supplierIds.filter((id) => !result.supplierIdsAlreadyRecorded.includes(id))
      if (filteredSupplierIds.length) {
        recordEvent("event19", {eVar27: 'Product1', list3: filteredSupplierIds.join()})
      }
      // record the RFQ lead for all suppliers selected in form
      recordEvent('event66,event19', {eVar27: 'Email', list3: result.supplierIds.join()}, 'Email Supplier Submitted');

      // This field is used to determine when web leads have already been recorded.
      // Update this field in both forms with the ID's we just finished recording for.
      $("input[name='supplierIdsAlreadyRecorded']").val(result.supplierIds.join())
    }).catch(() => {
      ProductEmailSupplierForm.showError("An Error occurred. Your message was not sent. Please try again later.")
      $("#email-supplier-dialog").removeClass("submitting")
    });
  }

  private static showError(message: string) {
    $("#email-supplier-dialog .error .message").html(message);
    $("#email-supplier-dialog #email-supplier-form").fadeIn(300)
    $("#email-supplier-dialog .error").fadeIn(300)[0].scrollIntoView({behavior: "smooth", block: "center"});
    $(".loading").hide()
  }

  private showSuccess(message: string) {
    $("#email-supplier-dialog .success .message").html(message);
    setTimeout(() => {
      $("#email-supplier-dialog .loading").fadeOut(300, () => {
        $("#email-supplier-dialog .success").css("display", "flex")
          .hide()
          .fadeIn(300)[0].scrollIntoView({behavior: "smooth", block: "center"})
      })
    }, 650)
  }

  private static showLoading() {
    $("#email-supplier-form").hide()
    $("#email-supplier-dialog .loading").fadeIn(300)[0].scrollIntoView({behavior: "smooth", block: "center"})
  }

  private static recordEmailSupplierFormEvent(event: string, description: string) {
    recordEvent(event, {eVar3: s.eVar3, eVar13: s.eVar13}, description)
  }

  private attachEventTracking() {
    $("#email-supplier-form textarea[name='message']").on('focusout', () => {
      ProductEmailSupplierForm.recordEmailSupplierFormEvent('event130', 'Email Supplier Form input: Message');
    });
  }
}

const resetEmailForm = () => {
  $("#email-supplier-dialog .loading, #email-supplier-dialog .success, #email-supplier-dialog .error").hide()
  $("#email-supplier-dialog #email-supplier-form").show()
}

export const showEmailForm = () => {
  resetEmailForm()

  const currentElement = $("#supplier-table-row-1 gs-button.supplier-site-link")
  const supplierRow = currentElement.closest(".supplier")

  const type = currentElement.data('type')
  const status = supplierRow.data('status')
  const supplierId = supplierRow.data('id')
  const productNumber = supplierRow.data('product-number')
  const isCanonical = supplierRow.data('is-canonical')
  const supplierType = supplierRow.data('type')

  const trackingVariables = {
    eVar27: type,
    eVar47: status,
    eVar4: supplierId,
    prop3: supplierId,
    eVar82: isCanonical,
    eVar83: supplierType,
    eVar95: productNumber
  }

  recordEvent('event65', trackingVariables, 'Email Supplier Click');

  if (Cookies.get("GSUSER") !== undefined) {
    instantiateReCaptcha("#email-supplier-form .captcha-wrapper");
    $('#email-supplier-dialog, #sitewide-overlay').fadeIn();
    $("html").animate({scrollTop: 0}, "slow");
  }
}